import { handler as handlerError } from '@/utils/message';

import {
  commissionsAPI,
} from '@/services';

export default {
  watch: {
    '$route.params': 'loadStartingData',
  },
  data: () => ({
    currentStep: 1,
    storageKey: 'indicated',
  }),
  computed: {
    indicatedManager() {
      return this.currentStep === 1;
    },
  },
  mounted() {
    this.canRender = true;
    this.loadStartingData();
  },
  methods: {
    // handlers
    // ...

    // handlers :: api
    async loadStartingData() {
      // reset data
      this.list.payments = [];
      this.showReceived = false;
      this.showToBeReceived = false;
      this.details.show = false;

      // update period
      this.updatePeriod();

      // get data
      await this.getCommission();
    },
    exportReport() {
      this.getCommissionByProposal(this.currentID, true);
    },

    // api
    async getCommission() {
      this.loading = true;
      this.data_table = [];

      await commissionsAPI
        .getIndicatedCommission({
          params: {
            ...this.pagination.financial.filters,
            ...await JSON.parse(sessionStorage.getItem(this.storageKey)),
            promoter_id: this.promoter_id,
          },
        })
        .then(({ data }) => {
          this.pagination.financial.data = data.data;
          this.data_table = data.data.data;
        })
        .catch(handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
    async getCommissionPaymentReport() {
      this.loading = true;

      await commissionsAPI
        .getIndicatedCommissionPaymentReport({
          params: {
            ...await JSON.parse(sessionStorage.getItem(this.storageKey)),
            ...(this.promoter_id ? { promoter_id: this.promoter_id } : ''),
          },
        })
        .then(({ data }) => {
          this.$set(this.list, 'payments', [
            {
              title: 'Recebido',
              value: data.data.paid_amount,
              updated_at: data.meta.datetime,
            },
            {
              title: 'Valor à Receber',
              value: data.data.pending_amount,
              updated_at: data.meta.datetime,
            },
          ]);
        })
        .catch(handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
    async getCommissionByProposal(id, shouldExport) {
      this.loading = true;
      this.currentID = id;

      if (!shouldExport) this.data_table = [];

      await commissionsAPI
        .getIndicatedCommissionByProposal({
          id,
          params: {
            promoter_id: this.promoter_id,
            ...(shouldExport ? { output: 'csv' } : ''),
          },
        })
        .then(({ data }) => {
          if (shouldExport) {
            this.handleExportRequest({ data, name: 'comissoes-indicadas' });
          } else {
            this.data_table = data.data;
            this.details.show = true;
          }
        })
        .catch(handlerError)
        .finally(() => {
          this.loading = false;
          this.details.show = true;
        });
    },
  },
};
